import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { accentColors } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledUsersIcon = styled(FontAwesomeIcon)`
  font-size: 2.4rem;
  color: ${({ theme }) => theme.colors.info.main};
`;

export const StyledHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
`;

export const StyledHeading = styled.span`
  font-size: 2.4rem;
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  color: ${({ theme }) => theme.colors.text.main};
`;

export const StyledOptionsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1.6rem;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    justify-content: flex-end;
  }
`;

export const StyledSearchIcon = styled(FontAwesomeIcon)<{ isDarkMode: boolean }>`
  && {
    color: ${({ theme, isDarkMode }) => (isDarkMode ? theme.colors.grey[400] : theme.colors.grey[700])};
  }
`;

export const StyledResetIcon = styled(FontAwesomeIcon)`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
`;

export const StyledBanIcon = styled(FontAwesomeIcon)<{ isBanned: boolean }>`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  color: ${({ theme, isBanned }) => (isBanned ? accentColors.error.light : theme.colors.grey[600])};
`;

export const StyledRecordsContainer = styled.div`
  flex-basis: 22rem;
`;

export const StyledSearchContainer = styled.div`
  flex-basis: 45.2rem;
`;

export const StyledDefaultText = styled.span`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  color: ${({ theme }) => theme.colors.text.main};
`;

export const StyledAvatarContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
`;

export const StyledPaginationContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    justify-content: center;
    gap: 2.4rem;
  }
`;

export const StyledRecordDetailText = styled.span`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  color: ${({ theme }) => theme.colors.text.lighter};
`;

// TODO [TI-1057] [2024-05-01] - Replace these mitigations when issues with ModularTable are resolved.
export const StyledModularTableWrapper = styled.div`
  margin-top: 2.4rem;
  margin-bottom: 2.4rem;

  div[role='table'] {
    overflow: unset;
    border-radius: ${({ theme }) => theme.radius.small};
    border: 0.1rem solid ${({ theme }) => theme.colors.border.main};
    @media (max-width: ${({ theme }) => theme.sizes.md}) {
      box-shadow: none;
    }
  }

  div[role='row'] {
    position: relative;
    transition: background-color 0.2s linear;
    padding: 3rem 0.5rem;
    @media (max-width: ${({ theme }) => theme.sizes.md}) {
      border: none;
      :not(:first-child) {
        border-top: 0.1rem solid ${({ theme }) => theme.colors.border.light};
      }
      :first-child:has(div[role='cell']) {
        border-top-right-radius: ${({ theme }) => theme.radius.small};
        border-top-left-radius: ${({ theme }) => theme.radius.small};
      }
    }
    @media (min-width: ${({ theme }) => theme.sizes.md}) {
      padding: 0;
      :first-child:has(div[role='columnheader']) {
        border-top-right-radius: ${({ theme }) => theme.radius.small};
        border-top-left-radius: ${({ theme }) => theme.radius.small};
      }
    }
    :last-child:has(div[role='cell']) {
      border-bottom-right-radius: ${({ theme }) => theme.radius.small};
      border-bottom-left-radius: ${({ theme }) => theme.radius.small};
    }
  }

  div[role='cell'] {
    @media (max-width: ${({ theme }) => theme.sizes.md}) {
      padding: 1rem;

      > div {
        flex: 1;
        :first-child {
          display: flex;
          align-items: center;
          margin-right: 1rem;
          flex: 0 1 40%;
        }
      }
    }
  }
`;
